import { defineComponent } from 'vue';
export default defineComponent({
  name: 'BlankContainer',
  setup(props) {
    return {};
  }
});